module.exports = __webpack_public_path__ + "static/media/overtime.e075b7bc.svg";